import React from 'react';
import ReactDOM from 'react-dom';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

import './v6/index.css';
import App from './v6/App';
import reportWebVitals from './reportWebVitals';

if (process.env.NODE_ENV === 'development') {
  const { worker } = require('./v6/mocks/browser');
  worker.start();
}

Bugsnag.start({
  apiKey: 'a2b4bbb53a20eb4d7810c5bc3c3d250d',
  plugins: [new BugsnagPluginReact()],
  onError: function (event) {
    try {
      const parsedEvent = JSON.parse(JSON.stringify(event));
      if (
        parsedEvent.exceptions[0].errorClass === 'InvalidError' &&
        parsedEvent.metaData['unhandledrejection handler']['non-error parameter'] === 'undefined'
      ) {
        /** return false to ignore this event, as throwing error with undefined is meaningless */
        return false;
      }
    } catch (e) {
      console.error(e);
    }
  },
});
// @ts-ignore
const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
